<form [ngrxFormState]="form" *ngIf="form$ | async; let form" class="w-100" autocomplete="off" role="presentation">
    <div id="login-container">
        <h3 class="subheader col-12">
            Join Verve Super in less than 5 minutes
        </h3>
        <div class="content col-12">
            <div class="row">
                <div class="col col-md-12 p-0">
                    <app-entry class="entry-dark-bg" title="First name (the one on your ID)"
                        [control]="form.controls.firstName">
                    </app-entry>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-12 p-0">
                    <app-entry class="entry-dark-bg" title="Last name (the one on your ID)"
                        [control]="form.controls.lastName">
                    </app-entry>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-12 p-0">
                    <app-entry class="entry-dark-bg" title="Email" entrytype="email" [control]="form.controls.email">
                    </app-entry>
                </div>
            </div>
        </div>
        <div class="card-bottom d-flex d-flex flex-row justify-content-end mt-3 mb-4 col-12">
            <app-button class="custom float-right" title="Next" icon="east" loading [isDisabled]="isLoading$ | async"
                (onClick)="onCreateLeadClick(form)">
            </app-button>
        </div>
        <div class="footer mt-3 col-12">
            <h5>
                Need help?
                <a href="https://vervesuper.com.au/contact-us/" target="_blank"><b>Contact
                        us</b>.</a>
            </h5>
            <p>
                By providing your email address, you consent
                and authorise us to send you communications or
                information, including information required by
                law, via email or similar technologies. Your
                details will never be passed onto a third
                party other than in accordance with our
                <a href="https://vervesuper.com.au/privacy-policy/" target="_blank">Privacy
                    Policy</a>. You can elect to receive communications by
                post at any time by contacting Verve Super on
                1300 799 482 or via email at
                <a href="mailto:hello@vervesuper.com.au" target="_blank">hello&#64;vervesuper.com.au</a>
                or in writing at GPO Box 2753, Brisbane QLD
                4001.
            </p>
            <p>
                All information is of a general nature only.
                As always, it’s important to do your own
                research and consider things like fees,
                investment performance, insurance, risk
                profile, and alignment with your values when
                considering if Verve Super is right for you.
                Consider seeking financial advice if you need
                help determining if Verve Super aligns with
                your financial needs. When considering
                performance, past performance is not
                indicative of future performance.
                <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund
                    information.</a>
            </p>
        </div>
    </div>
</form>